const state = {
  alerts: {
    type: "",
    message: "",
  },
  active: false,
};

const mutations = {
  SET_ALERT(state, payload) {
    state.alerts.type = payload.type;
    state.alerts.message = payload.message;
    state.active = true;
  },

  REMOVE_ALERT(state) {
    state.active = false;
  },
};

const actions = {
  setAlert({ commit }, payload) {
    commit("SET_ALERT", payload);
  },

  removeAlert({ commit }, payload) {
    commit("REMOVE_ALERT", payload);
  },
};

const getters = {
  getAlert: (state) => state.alerts,
  getActive: (state) => state.active,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
